import React from 'react';
import cn from 'classnames';

import ActivationBox from '../ActivationBox';
import LoadingIcon from '../../../assets/icons/common/LoadingIcon';

import styles from './styles.module.scss';

const ActivationProcessing = ({ type }) => {
  const message = type === 'payment' ? 'Payment' : 'Activation';
  return (
    <ActivationBox className={styles.wrapper}>
      <LoadingIcon className={styles.icon} />
      <h3 className={cn('h3', styles.title)}>{message} is in process...</h3>
      <p className={cn('text', styles.text)}>
        Do not refresh this page until {message.toLowerCase()} is complete.
      </p>
    </ActivationBox>
  );
};

export default ActivationProcessing;
